import React, { Component } from 'react';
import { Modal, Table, ButtonToolbar, Button } from 'react-bootstrap';

export class OrderSetter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: this.props.data
        }
    }

    // -----------------

    onSave() {
        const { data } = this.state;
        this.props.onSave(data);
    }

    onDragOver(e) {
        e.preventDefault();
    }

    onDragStart(e, idx) {
        e.dataTransfer.setData('index', idx);
    }

    onDrop(e) {
        const oldIndex = e.dataTransfer.getData('index');
        const newIndex = e.target.dataset.value;

        if (undefined !== oldIndex && undefined !== newIndex && oldIndex !== newIndex) {
            const { data } = this.state;

            const oldIndexValue = data[oldIndex];
            data.splice(oldIndex, 1);
            data.splice(newIndex, 0, oldIndexValue);

            this.setState({
                data: data
            });
        }
    }

    // -------------------

    render() {
        const { title, header, getValueCallback } = this.props;
        const { data } = this.state;

        if (undefined === data || null === data || !Array.isArray(data)) {
            return null;
        }

        return (
            <Modal show={true}>
                <Modal.Header>
                    <Modal.Title>Definir Ordem - {title}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Table responsive striped hover>
                        <thead>
                            <tr>
                                <th>{header}</th>
                            </tr>
                        </thead>
                        <tbody onDrop={(a) => this.onDrop(a)}>
                            {
                                data.map((item, idx) =>
                                    <tr key={`ordered-item-${idx}`}
                                        draggable={true}
                                        onDragOver={(a) => this.onDragOver(a)}
                                        onDragStart={(a) => this.onDragStart(a, idx)}>

                                        <td data-value={idx}>{getValueCallback(item)}</td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </Table>
                    <ButtonToolbar>
                        <Button onClick={() => this.onSave()}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={() => this.props.onHide()}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}
